import "./StudyPlaner.css";
import React, { useState, useEffect } from "react";
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-calendars/styles/material.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "../../../../axios";
import { DialogComponent } from "@syncfusion/ej2-react-popups";
export default function EditStudyPlanner({ event, setClicked }) {
  console.log(event);
  let variables = JSON.parse(localStorage.getItem("breathForStudent"));
  let stdid = variables?.standard?.id;
  let secid = variables?.section?.id;
  const getDayOutOfDate = (para) => {
    const dateString = para;
    const date = new Date(dateString);
    const options = { weekday: "long" };

    const day = date.toLocaleString("en-US", options);

    return day; // Output: Saturday
  };
  const [studyPlanner, setStudyPlanner] = useState({
    selectedDays: [getDayOutOfDate(event.StartTime)],
    selectedTime: event.StartTime,
    selectedEndTime: event.EndTime,
    subject: event.Subject,
    subject_id: event.Subject_id,
    plannerName: event.name,
    description: event.description,
    errorMessage: ""
  });
  // const [thisPlanner, setThisPlanner] = useState(true);
  const [allPlanner, setAllPlanner] = useState(false);
  const [sucess, setSucess] = useState(false);
  const picktimefromString = (para) => {
    const dateString = para;
    const dateObject = new Date(dateString);
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const time =
      String(hours).padStart(2, "0") + String(minutes).padStart(2, "0");

    return time;
  };
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  }
  const handleSaveChange = async () => {
    // It's part of remove radio button
    if (allPlanner) {
      let body = {
        name: `${studyPlanner.plannerName}`,
        start_time: picktimefromString(studyPlanner.selectedTime),
        end_time: picktimefromString(studyPlanner.selectedEndTime),
        subject_id: studyPlanner.subject_id,
        day: studyPlanner.selectedDays[0],
        description: studyPlanner.description,
        date: formatDate(event?.StartTime),
        update_recurrence: true,
      };
      let res = await axios.post(
        `/studyPlanner/${event.studyPlanner_id}/lecture/updateSeries/lectureId/${event.lecture_id}/timetableSession/${variables.timetable_session.id}`,
        body
      );
      if (res.status === 200) {
        // window.location.reload();
        setSucess(true);
      }
    } else {
      let body = {
        name: `${studyPlanner.plannerName}`,
        start_time: picktimefromString(studyPlanner.selectedTime),
        end_time: picktimefromString(studyPlanner.selectedEndTime),
        subject_id: studyPlanner.subject_id,
        day: studyPlanner.selectedDays[0],
        description: studyPlanner.description,
        date: formatDate(event?.StartTime),
        update_recurrence: false,
      };
      let res = await axios.post(
        `/studyPlanner/${event.studyPlanner_id}/lecture/updateSeries/lectureId/${event.lecture_id}/timetableSession/${variables.timetable_session.id}`,
        body
      );
      if (res.status === 200) {
        // window.location.reload();
        setSucess(true);
      }
    }
  };

  const [subjectList, setSubjectList] = useState([]);
  useEffect(() => {
    axios
      .get(`/school/standardId/${stdid}/sectionId/${secid}/getSubjects`)
      .then((res) => {
        setSubjectList(res.data.data.subjects);
      });
  }, []);
  const handleSelectDayClick = () => {
    setStudyPlanner((prevState) => ({
      ...prevState,
      selectDay: !prevState.selectDay,
    }));
  };

  const handleTimeChange = (time) => {
    console.log("time", time)
    if (studyPlanner?.selectedEndTime && time > studyPlanner?.selectedEndTime) {
      setStudyPlanner((prevState) => ({
        ...prevState,
        selectedTime: time,
        errorMessage: "Error! Start time cannot be after end time.",
      }));
    } else {
      setStudyPlanner((prevState) => ({
        ...prevState,
        selectedTime: time,
        errorMessage: "",
      }));
      setIsDatePickerOpen(false)
    }
  };

  const handleEndTimeChange = (endTime) => {
    if (studyPlanner?.selectedTime && endTime < studyPlanner?.selectedTime) {
      setStudyPlanner((prevState) => ({
        ...prevState,
        selectedEndTime: endTime,
        errorMessage: "Error! End time cannot be before start time.",
      }));
    } else {
      setStudyPlanner((prevState) => ({
        ...prevState,
        selectedEndTime: endTime,
        errorMessage: "",
      }));
      setIsDatePickerOpenEnd(false);
    }
  };

  const handleSubjectChange = (event) => {
    event.stopPropagation()
    setStudyPlanner((prevState) => ({
      ...prevState,
      subject_id: event?.target.value,
    }));
  };

  const handlePlannerNameChange = (e) => {
    setStudyPlanner((prevState) => ({
      ...prevState,
      plannerName: e.target.value
    }));
  };

  const handleDescriptionChange = (event) => {
    setStudyPlanner((prevState) => ({
      ...prevState,
      description: event.target.value,
    }));
  };
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [isDatePickerOpenEnd, setIsDatePickerOpenEnd] = useState(false);

  const toggleDatePicker = () => {
    setIsDatePickerOpen(!isDatePickerOpen);
  };
  const toggleDatePickerEnd = () => {
    setIsDatePickerOpenEnd(!isDatePickerOpenEnd);
  };
  let buttons1 = [
    {
      buttonModel: {
        content: "Okay",
        class: "discard_btn",
        isPrimary: true,
      },
      click: () => {
        window.location.reload();
        // cose(false);
      },
    },
  ];
  return (
    <div className="ContainerStudyPlaner">
      {!sucess && <div className="SubContainerStudyPlaner p-4">
        <div className="studyplanner">{`Edit Study Planner (${event?.name})`}</div>
        <select
          className="plannerSubject mt-3"
          onClick={handleSubjectChange}
        >
          <option>Select Subject</option>
          {subjectList.map((obj, i) => (
            <option
              key={obj.id}
              value={obj.id}
              selected={obj.id === event.Subject_id ? true : false}
            >
              {obj.name}
            </option>
          ))}
        </select>
        {/* <DropDownEditPlanner studyPlanner={studyPlanner} subjectList={subjectList} handleSubjectChange={handleSubjectChange} /> */}
        {/* Remove radio button from day edit study planner */}
        {/* {event?.Recurrence && (
          <div className="d-flex mt-2">
            <div className="mr-3">
              <input
                type="radio"
                className="mr-1"
                name="planner1"
                checked={thisPlanner}
                onChange={() => {
                  let isFalse2 = thisPlanner;
                  setThisPlanner(!isFalse2);
                  setAllPlanner(isFalse2 ? true : false);
                }}
              ></input>
              <span className="StdPlan mb-2">This Study Planner</span>
            </div>
            <div>
              <input
                type="radio"
                className="mr-1"
                name="planner2"
                checked={allPlanner}
                onChange={() => {
                  let isFalse1 = allPlanner;
                  setAllPlanner(!isFalse1);
                  setThisPlanner(isFalse1 ? true : false);
                }}
              ></input>
              <span className="StdPlan mb-2">
                This and Following Study Planner
              </span>
            </div>
          </div>
        )} */}
        <div className="d-flex gap-3 mt-3">
          <div className="selectTimeContainer  d-flex align-items-center justify-content-between">
            <div className="outerDivTimepicker1cr d-flex align-items-center" onClick={(e) => {
              e.stopPropagation()
            }}>
              <DatePicker
                selected={studyPlanner?.selectedTime}
                onChange={handleTimeChange}
                showTimeSelect
                showTimeSelectOnly

                timeIntervals={15}
                timeCaption="Start time"
                dateFormat="h:mm aa"
                placeholderText="Start time"
                className="startTimeStudyPlanner"
                open={isDatePickerOpen}
                onClickOutside={toggleDatePicker}
              />
              <div onClick={(e) => {
                e.stopPropagation()
                toggleDatePicker()
              }}>
                <img src="/DCM-img/DownArrow.png" alt="Up Arrow" />
              </div>
            </div>

            <div className="outerDivTimepickercr d-flex justify-content-end" onClick={(e) => {
              e.stopPropagation()
            }} >
              <DatePicker
                selected={studyPlanner?.selectedEndTime}
                onChange={handleEndTimeChange}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={15}
                timeCaption="End time"
                dateFormat="h:mm aa"
                placeholderText="End time"
                className="startTimeStudyPlanner mt-2"
                open={isDatePickerOpenEnd}
                onClickOutside={toggleDatePickerEnd}
                width={100}
              />
              <div onClick={(e) => {
                e.stopPropagation()
                toggleDatePickerEnd()
              }
              }>
                <img
                  src="/DCM-img/DownArrow.png"
                  alt="Up Arrow"
                  className="mt-3"
                />
              </div>
            </div>
            {/* <div className="mainRpt">
             
            </div> */}
          </div>
          {/* <div className="selectDayContainer  align-items-center p-2">
            <div className="d-flex align-items-center justify-content-between">
              <div className="selectDay">{studyPlanner?.selectedDays[0]}</div>
              <div>
                <img src="/DCM-img/DownArrow.png" alt="Down Arrow" />
              </div>
            </div>
          </div> */}
        </div>
        <div onClick={(e) => {
          e.stopPropagation()
        }}>
          <input
            className="plannerSubject mt-3"
            value={studyPlanner?.plannerName}
            placeholder="Study planner name"
            onChange={handlePlannerNameChange}
            maxLength={20}
          />
        </div>
        <div onClick={(e) => {
          e.stopPropagation()
        }}>
          <textarea
            className="DescriptionPlanner d-flex mt-3"
            value={studyPlanner?.description}
            placeholder="Description"
            onChange={handleDescriptionChange}
            maxLength={250}
          />
        </div>
        <div>
          <img
            className="crossIcon"
            src="/DCM-img/crossIcon.svg"
            alt="Up Arrow"
            onClick={(e) => {
              e.stopPropagation()
              setClicked(false);
            }}
          />
        </div>
        <div className="d-flex justify-content-end gap-4 mt-4">
          <button
            className="DiscardPlannerBtn"
            onClick={(e) => {
              e.stopPropagation()
              setClicked(false);
            }}
          >
            Discard Changes
          </button>
          <button className="createPlannerBtn" onClick={handleSaveChange}>
            Save Changes
          </button>
        </div>
      </div>}
      {/* set the success popup box alignment */}
      {
        sucess && <DialogComponent
          width={"800px"}
          style={{ marginTop: "200px", marginLeft: "350px" }}
          position={{ X: "center center", Y: "center center" }}
          allowDragging={true}
          showCloseIcon={true}
          // open={() => close(true)}
          close={() => setSucess(false)}
          buttons={buttons1}
        >
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
            <img
              src="/images/SucessDel.svg"
              alt=""
              style={{ width: "100px", marginBottom: "20px" }}
            />
            <p
              style={{
                fontWeight: "600",
                fontSize: "24px",
              }}
            >
              Changes Saved Sucessfully.
            </p>
          </div>
        </DialogComponent>
      }
    </div >
  );
}
